module.exports = __webpack_public_path__ + "img/92.d84cfd3d.svg";